import { useNewCode } from '@calendly/feature-check-react';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getContactDisplayName, getPreferredContactName } from 'shared/utils/get_contact_display_name';
import { CRM_NEEDS_ATTENTION_FLAG_KEY, getNonContactRecipientLabel, isGmailRecipientWithBrandmark, isTypedNonContactRecipient } from 'shared/utils/non_contact_recipient';
import { ContactRecipientAvatar } from './contact_recipient_avatar';
const containerCss = "c1m2hh5x";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const columnCss = "c1hrx1te";
const Column = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(columnCss, props.className)} />;
});
export const ContactItem = ({
  contact
}) => {
  const isNonContactUiEnabled = useNewCode(CRM_NEEDS_ATTENTION_FLAG_KEY, false)?.enabled;
  const isTypedNonContact = isNonContactUiEnabled && isTypedNonContactRecipient(contact);
  const preferredName = getPreferredContactName(contact);
  const displayName = isTypedNonContact ? getNonContactRecipientLabel(contact) : getContactDisplayName(contact);
  const showGmailBrandmark = isNonContactUiEnabled && isGmailRecipientWithBrandmark(contact);
  return <Container>
      <ContactRecipientAvatar contact={contact} size="small" isNonContactUiEnabled={isNonContactUiEnabled} showGmailBrandmark={showGmailBrandmark} />
      <Column>
        <BodyText><FullStoryMask>{displayName}</FullStoryMask></BodyText>
        {!isTypedNonContact && !!preferredName && !!contact.email && <BodyText color="muted" size="medium"><FullStoryMask>{contact.email}</FullStoryMask></BodyText>}
      </Column>
    </Container>;
};

require("./contact_item.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_item.js");